import {LoadImages} from '../load/LoadImages';
// const SizesUtils = require('../../../../../viscomjs/utils/SizesUtils');
// import {textureURLBase} from '../../../settings/resources';
import {textureURLBaseLoc} from '../../../settings/resources';

// const isProd = process.env.NODE_ENV === 'production';

const PrepareTextures = (num, doThat, progressUpdate, storage, config) => {
    const manifest = [];
    // const size = SizesUtils.winWidth() < 768 || SizesUtils.winHeight() < 768 ? 2 : 1;
    let i;

    /* if (isProd) {
        for (i = 1; i < num + 1; i++) {
            manifest.push({id: `txr-${i}`, url: `${textureURLBase}?type=${i}&size=${size}`});
        }
    } else {*/
    for (i = 1; i < num + 1; i++) {
        manifest.push({id: `txr-${i}`, url: `${textureURLBaseLoc}texture_${i}.png`});
    }
    /* }*/

    return LoadImages(manifest, doThat, progressUpdate, storage, config);
};

const PrepareTexturesFunction = (num, progressUpdate, storage, config) => {
    return doThat => {
        return PrepareTextures(num, doThat, progressUpdate, storage, config);
    };
};

export {PrepareTextures, PrepareTexturesFunction};
export default PrepareTextures;
